import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MatTabGroup } from '@angular/material';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sub-item',
  templateUrl: './sub-item.component.html',
  styleUrls: ['./sub-item.component.css']
})
export class SubItemComponent implements OnInit {

  public menu_item_id = '59';
  public add_auth;

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  // acctDialogRef: MatDialogRef<SearchAcctsComponent>;
  // public search_dialog_data = {}; , public dialog: MatDialog, private dialogRef: MatDialogRef<SubItemComponent>, 
  // @Inject(MAT_DIALOG_DATA) public dialog_data: any
  // subItemCatDialogRef: MatDialogRef<SubItemCatComponent>;
  // public sub_dialog_data;

  revenueList = [];
  revenueDetail = '';
  expenseList = [];
  expenseDetail = '';
  saleRetList = [];
  saleRetDetail = '';
  purchRetList = [];
  purchRetDetail = '';

  itemCats = [];
  all_itemSubCats = [];
  itemSubCats = [];
  taxes = [];
  consumeList = [{ 'stock_consume': 'FIFO', 'consume_name': 'الداخل أولاً صادر أولاً - FIFO' },
  { 'stock_consume': 'LIFO', 'consume_name': 'الداخل أخراً صادر أولاً - LIFO' }];

  mainItem_model = {
    'table_name': 'main_item', 'main_item_id': '0', 'main_item_name': '', 'main_item_name_en': '',
    'item_subcat_id': '0', 'main_item_type': 'simple', 'stock_link': 0, 'main_item_desc': '',
    'revenue_acct_no': '0', 'expense_acct_no': '0', 'sale_ret_acct_no': '0', 'purch_ret_acct_no': '0',
    'def_tax_acct': '0', 'is_expire': 0, 'stock_consume': '', 'offer_id': '0', 'flag': 'new',
    'key': 'main_item_id', 'comment': ''
  };

  data_model = {
    'item_cat_id': '0', 'revenue_acct_name': '', 'expense_acct_name': '', 'sale_ret_acct_name': '',
    'purch_ret_acct_name': ''
  };

  search_acct = {
    'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`sub_acct`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
      'condition': " AND `sub_acct`.`is_leaf` = '1'"
    }]
  };

  // search_revenue = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //     'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //     'condition': " AND `sub_acct`.`is_leaf` = '1'"
  //   }]
  // };

  // search_expense = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [{
  //     'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //     'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //     'condition': " AND `sub_acct`.`is_leaf` = '1'"
  //   }]
  // };

  // search_asset = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [
  //     {
  //       'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //       'condition': " AND (`sub_acct`.`acct_type_no` = '1' OR `sub_acct`.`acct_type_no` = '2' OR `sub_acct`.`acct_type_no` = '3')"
  //     },
  //     {
  //       'table_name': '`customer`', 'selected_no': 'customer_no',
  //       'field_list': ['customer_no', 'customer_name', 'customer_name_en']
  //     },
  //     {
  //       'table_name': '`bank_account`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'bank_acct_number', 'account_name', 'account_name_en']
  //     },
  //     {
  //       'table_name': '`fixed_asset`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'asset_number', 'asset_name', 'asset_name_en']
  //     }]
  // };

  // search_liability = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [
  //     {
  //       'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
  //       'condition': " AND (`sub_acct`.`acct_type_no` = '4' OR `sub_acct`.`acct_type_no` = '5')"
  //     },
  //     {
  //       'table_name': '`supplier`', 'selected_no': 'supplier_no',
  //       'field_list': ['supplier_no', 'supplier_name', 'supplier_name_en']
  //     },
  //     {
  //       'table_name': '`tax`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'tax_name_ar', 'tax_name_en']
  //     }]
  // };

  units = [];
  subItemList = [];
  displayedColumns = ['sub_item_no', 'unit_name', 'cost', 'price', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.subItemList);
  @ViewChild(MatSort) sort: MatSort;
  // subItemList = [];
  private subItemContList = [];
  contDisplayedColumns = ['sub_item_no', 'main_item_name', 'unit_name', 'quantity', 'cost', 'total_cost', 'price',
    'total_price', 'edit', 'del'];
  contDataSource = new MatTableDataSource(this.subItemContList);

  changedAcct = false;

  subItem_model = {
    'table_name': 'sub_item', 'sub_item_id': '0', 'sub_item_number': '0', 'main_item_id': '', 'unit_id': '0',
    'unit_name': '', 'from_unit': '0', 'unit_quantity': 0, 'no_barcode': 1, 'sub_item_no': '', 'flag': 'new',
    'key': 'sub_item_id', 'price': 0, 'total_price': 0, 'cost': 0, 'total_cost': 0, 'min_qty': 0, 'min_sale_qty': 1,
    'price_flex': 0, 'min_price': 0, 'is_sale': 0, 'is_purch': 0, 'sub_item_cont': [], 'warranty_day': '', 'warranty_kilometer': ''
  };

  cont_model = {
    'table_name': 'sub_item_content', 'sub_item_content_id': '0', 'sub_item_number': '', 'content_number': '',
    'sub_item_no': '', 'flag': 'new', 'key': 'sub_item_content_id', 'unit_id': '', 'unit_name': '', 'main_item_name': '',
    'quantity': 0, 'cost': 0, 'total_cost': 0, 'price': 0, 'total_price': 0, 'price_flex': 0
  };

  heightField = '';

  sub_item_search = {
    'placeholder': 'رقم أو اسم الصنف', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'sub_item_no',
      'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`', 'join_field_list': ['sub_item_no'],
      'join_condition': " AND `main_item`.`main_item_id` = `sub_item`.`main_item_id`"
    }]
  };

  old_unit_id;
  public show_primary_unit = true;
  // ((mainItem_model.main_item_id == '0' && subItemList.length == 0) || (mainItem_model.main_item_id != '0' && subItem_model.sub_item_id != '0' && subItem_model.from_unit == '0'))
  // ((mainItem_model.main_item_id == '0' && subItemList.length > 0) || 
  //                 (mainItem_model.main_item_id != '0' && (subItem_model.sub_item_id != '0' && subItem_model.from_unit != '0' || (subItem_model.sub_item_id == '0' && subItemList.length > 0))))">
  // ((mainItem_model.main_item_id == '0' && subItemList.length > 0) || 
  //             (mainItem_model.main_item_id != '0' && (subItem_model.sub_item_id != '0' && subItem_model.from_unit != '0' || (subItem_model.sub_item_id == '0' && subItemList.length > 0))))
  // oldUnit = [];
  Sub_item_Placeholder; Fifo; Lifo; Acct_Placeholder; Del_Content_Msg; Sub_Item_No_Msg;
  Qty_Msg; Unit_Msg; Del_Sub_Item; Main_Cat_Msg; Sub_Cat_Msg; Sub_Item_Name_Msg; Cat_Msg;
  Revenue_Acct_Msg; Expense_Acct_Msg; Cat_Unit_Msg; Cat_Error_Msg; Cat_Edit_Err_Msg;
  Cat_Inf_Err_Msg; Content_Error_Msg; New_Cat_Error_Msg; Success_Msg; Error_Msg;


  // public dialog: MatDialog
  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private route: ActivatedRoute, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Sub_item_Placeholder').subscribe((res: string) => {
      this.Sub_item_Placeholder = res;
    });
    this.sub_item_search['placeholder'] = this.Sub_item_Placeholder;

    translate.get('Fifo').subscribe((res: string) => {
      this.Fifo = res;
    });
    this.consumeList['0']['consume_name'] = this.Fifo;

    translate.get('Lifo').subscribe((res: string) => {
      this.Lifo = res;
    });
    this.consumeList['1']['consume_name'] = this.Lifo;

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    // this.search_revenue['placeholder'] = this.Acct_Placeholder;
    // this.search_expense['placeholder'] = this.Acct_Placeholder;
    // this.search_asset['placeholder'] = this.Acct_Placeholder;
    // this.search_liability['placeholder'] = this.Acct_Placeholder;


    translate.get('Del_Content_Msg').subscribe((res: string) => {
      this.Del_Content_Msg = res;
    });

    translate.get('Sub_Item_No_Msg').subscribe((res: string) => {
      this.Sub_Item_No_Msg = res;
    });

    translate.get('Qty_Msg').subscribe((res: string) => {
      this.Qty_Msg = res;
    });

    translate.get('Unit_Msg').subscribe((res: string) => {
      this.Unit_Msg = res;
    });

    translate.get('Del_Sub_Item').subscribe((res: string) => {
      this.Del_Sub_Item = res;
    });

    translate.get('Main_Cat_Msg').subscribe((res: string) => {
      this.Main_Cat_Msg = res;
    });

    translate.get('Sub_Cat_Msg').subscribe((res: string) => {
      this.Sub_Cat_Msg = res;
    });

    translate.get('Sub_Item_Name_Msg').subscribe((res: string) => {
      this.Sub_Item_Name_Msg = res;
    });

    translate.get('Cat_Msg').subscribe((res: string) => {
      this.Cat_Msg = res;
    });

    translate.get('Revenue_Acct_Msg').subscribe((res: string) => {
      this.Revenue_Acct_Msg = res;
    });

    translate.get('Expense_Acct_Msg').subscribe((res: string) => {
      this.Expense_Acct_Msg = res;
    });

    translate.get('Cat_Unit_Msg').subscribe((res: string) => {
      this.Cat_Unit_Msg = res;
    });

    translate.get('Cat_Error_Msg').subscribe((res: string) => {
      this.Cat_Error_Msg = res;
    });

    translate.get('Cat_Edit_Err_Msg').subscribe((res: string) => {
      this.Cat_Edit_Err_Msg = res;
    });

    translate.get('Cat_Inf_Err_Msg').subscribe((res: string) => {
      this.Cat_Inf_Err_Msg = res;
    });

    translate.get('Content_Error_Msg').subscribe((res: string) => {
      this.Content_Error_Msg = res;
    });

    translate.get('New_Cat_Error_Msg').subscribe((res: string) => {
      this.New_Cat_Error_Msg = res;
    });
    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    let href = this.router.url;
    let urlParts = href.split("/");

    if (urlParts[2] == '5')
      this.menu_item_id = '59';
    else if (urlParts[2] == '12')
      this.menu_item_id = '76';

    let query, obj;

    // get leaf income accts
    let parent_acct = this.applicationConstants.main_acct_config['income_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.revenueList = data.data['list'];
      });


    // get leaf expenses accts
    parent_acct = this.applicationConstants.main_acct_config['expenses_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.expenseList = data.data['list'];
      });

    // get leaf sale return accts
    parent_acct = this.applicationConstants.main_acct_config['income_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.saleRetList = data.data['list'];
      });

    // get leaf purchase return accts
    parent_acct = this.applicationConstants.main_acct_config['expenses_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.purchRetList = data.data['list'];
      });



    query = this.queryList.all_itemCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.itemCats = data.data['list'];
      });

    query = this.queryList.all_itemSubCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_itemSubCats = data.data['list'];
      });

    query = this.queryList.all_tax_types;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.taxes = data.data['list'];
        let selObj = { 'tax_id': '0', 'acct_number': '0', 'tax_name_ar': 'بدون ضريبة', 'tax_name_en': 'Without Tax' };
        this.taxes.unshift(selObj);
      });

    query = this.queryList.all_unit;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.units = data.data['list'];
      });

    this.route.params.subscribe(params => {
      if (params['id'] != undefined) {
        this.mainItem_model['main_item_id'] = params['id'];

        // get main item 
        query = "SELECT `main_item`.*, `item_subcat`.`item_cat_id` FROM `main_item`, `item_subcat` WHERE `main_item_id` = '" +
          this.mainItem_model['main_item_id'] + "' AND `main_item`.`item_subcat_id` = `item_subcat`.`item_subcat_id`";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let main_item_obj = data.data['list'][0];
            this.mainItem_model['main_item_name'] = main_item_obj['main_item_name'];
            this.mainItem_model['main_item_name_en'] = main_item_obj['main_item_name_en'];
            this.data_model['item_cat_id'] = main_item_obj['item_cat_id'];
            this.mainItem_model['item_subcat_id'] = main_item_obj['item_subcat_id'];
            this.mainItem_model['main_item_type'] = main_item_obj['main_item_type'];
            this.mainItem_model['stock_link'] = (main_item_obj['stock_link'] == '1' ? 1 : 0);
            this.mainItem_model['main_item_desc'] = main_item_obj['main_item_desc'];
            this.mainItem_model['revenue_acct_no'] = main_item_obj['revenue_acct_no'];
            this.mainItem_model['expense_acct_no'] = main_item_obj['expense_acct_no'];
            this.mainItem_model['sale_ret_acct_no'] = main_item_obj['sale_ret_acct_no'];
            this.mainItem_model['purch_ret_acct_no'] = main_item_obj['purch_ret_acct_no'];
            // this.mainItem_model['asset_acct_no'] = main_item_obj['asset_acct_no'];
            // this.mainItem_model['liability_acct_no'] = main_item_obj['liability_acct_no'];
            this.mainItem_model['def_tax_acct'] = main_item_obj['def_tax_acct'];
            this.mainItem_model['is_expire'] = (main_item_obj['is_expire'] == '1' ? 1 : 0);
            this.mainItem_model['stock_consume'] = main_item_obj['stock_consume'];
            this.mainItem_model['offer_id'] = main_item_obj['offer_id'];
            this.mainItem_model['comment'] = main_item_obj['comment'];
            this.mainItem_model['flag'] = 'update';

            this.getSubCat(true);
            this.fillAcctField();

            // get sub item list
            if (this.mainItem_model['main_item_type'] == 'simple') {

              query = "SELECT `sub_item`.*, `unit`.`unit_name` FROM `sub_item`, `unit` WHERE `sub_item`.`main_item_id` = '" +
                this.mainItem_model['main_item_id'] + "' AND `sub_item`.`status` = '1' AND `sub_item`.`unit_id` = `unit`.`unit_id`";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  let sub_data = data.data['list'];
                  let index = 0;

                  sub_data.forEach(element => {
                    this.subItemList.push({
                      'table_name': 'sub_item', 'sub_item_id': element.sub_item_id, 'sub_item_number': element.sub_item_number,
                      'main_item_id': element.main_item_id, 'unit_id': element.unit_id, 'unit_name': element.unit_name,
                      'from_unit': element.from_unit, 'unit_quantity': element.unit_quantity, 'no_barcode': 0,
                      'sub_item_no': element.sub_item_no, 'flag': 'update', 'key': 'sub_item_id',
                      'price': element.price, 'total_price': 0, 'cost': element.cost, 'total_cost': 0,
                      'min_qty': element.min_qty, 'min_sale_qty': element.min_sale_qty,
                      'price_flex': (element.price_flex == '1' ? 1 : 0),
                      'min_price': element.min_price, 'is_sale': (element.is_sale == '1' ? 1 : 0),
                      'is_purch': (element.is_purch == '1' ? 1 : 0), 'sub_item_cont': [], 'index': index,
                      'warranty_day': element.warranty_day, 'warranty_kilometer': element.warranty_kilometer
                    });
                    // this.oldUnit.push({ 'sub_item_id': element.sub_item_id, 'unit_id': element.unit_id });
                    index++;
                  });

                  // this.dp = this.subItemList;
                  this.dataSource = new MatTableDataSource(this.subItemList);
                  this.dataSource.sort = this.sort;
                  // console.log(this.oldUnit);
                });
            }
            else if (this.mainItem_model['main_item_type'] == 'industrial') {
              obj = { cmd: 'getIndustSubItem', main_item_id: this.mainItem_model['main_item_id'] };

              this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  // console.log(data.data['list']);
                  this.subItemList = data.data['list'];
                  // this.subItemList.forEach(element => {
                  //   this.oldUnit.push({ 'sub_item_id': element.sub_item_id, 'unit_id': element.unit_id });
                  // });
                  this.dataSource = new MatTableDataSource(this.subItemList);
                  this.dataSource.sort = this.sort;
                  // console.log(this.oldUnit);
                });
            }
            this.show_primary_unit = false;
          });
      }
    });

    // check add authorization
    if (this.mainItem_model['main_item_id'] == '0')
      this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    else
      this.add_auth = true;
    // this.mainItem_model['main_item_id'] = this.dialog_data;
  }

  selectedTab(event) {
    if (event.index == 0 && this.heightField != '') {
      (document.getElementById(this.heightField) as HTMLInputElement).focus();
      this.heightField = '';
    }
    if (event.index == 1 && this.changedAcct) {
      (document.getElementById("search_value_0") as HTMLInputElement).value = this.data_model['revenue_acct_name'];
      (document.getElementById("search_value_1") as HTMLInputElement).value = this.data_model['expense_acct_name'];
      (document.getElementById("search_value_2") as HTMLInputElement).value = this.data_model['sale_ret_acct_name'];
      (document.getElementById("search_value_3") as HTMLInputElement).value = this.data_model['purch_ret_acct_name'];
    }
  }

  getSubCat(filter_only = null) {
    this.itemSubCats = [];
    this.all_itemSubCats.forEach(element => {
      if (element.item_cat_id == this.data_model['item_cat_id'])
        this.itemSubCats.push(element);
    });

    if (filter_only == null) {
      this.mainItem_model['item_subcat_id'] = '0';
      if (this.itemSubCats.length > 0)
        this.mainItem_model['item_subcat_id'] = this.itemSubCats['0']['item_subcat_id'];
      //console.log(this.mainItem_model['item_subcat_id']);

      this.mainItem_model['def_tax_acct'] = '0';
      this.mainItem_model['revenue_acct_no'] = '0';
      this.mainItem_model['expense_acct_no'] = '0';
      this.mainItem_model['sale_ret_acct_no'] = '0';
      this.mainItem_model['purch_ret_acct_no'] = '0';

      this.changeItemSubcat();

      // this.fillAcctField();
    }
  }

  fillAcctField() {
    this.changedAcct = true;
    let query, obj;

    if (this.mainItem_model['revenue_acct_no'] != '0') {
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.mainItem_model['revenue_acct_no'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            // (document.getElementById("search_value_0") as HTMLInputElement).value 
            this.data_model['revenue_acct_name'] = data.data['list'][0]['acct_number'] +
              "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
            this.revenueDetail = this.data_model['revenue_acct_name'];
          }
        });
    }
    else
      // (document.getElementById("search_value_0") as HTMLInputElement).value
      this.data_model['revenue_acct_name'] = '';

    if (this.mainItem_model['expense_acct_no'] != '0') {
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.mainItem_model['expense_acct_no'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            // (document.getElementById("search_value_1") as HTMLInputElement).value
            this.data_model['expense_acct_name'] = data.data['list'][0]['acct_number'] +
              "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
            this.expenseDetail = this.data_model['expense_acct_name'];
          }
        });
    }
    else
      // (document.getElementById("search_value_1") as HTMLInputElement).value
      this.data_model['expense_acct_name'] = '';

    if (this.mainItem_model['sale_ret_acct_no'] != '0') {
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.mainItem_model['sale_ret_acct_no'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            // (document.getElementById("search_value_0") as HTMLInputElement).value 
            this.data_model['sale_ret_acct_name'] = data.data['list'][0]['acct_number'] +
              "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
            this.saleRetDetail = this.data_model['sale_ret_acct_name'];
          }
        });
    }
    else
      // (document.getElementById("search_value_0") as HTMLInputElement).value
      this.data_model['sale_ret_acct_name'] = '';

    if (this.mainItem_model['purch_ret_acct_no'] != '0') {
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.mainItem_model['purch_ret_acct_no'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            // (document.getElementById("search_value_1") as HTMLInputElement).value
            this.data_model['purch_ret_acct_name'] = data.data['list'][0]['acct_number'] +
              "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
            this.purchRetDetail = this.data_model['purch_ret_acct_name'];
          }
        });
    }
    else
      // (document.getElementById("search_value_1") as HTMLInputElement).value
      this.data_model['purch_ret_acct_name'] = '';

    // if (this.mainItem_model['asset_acct_no'] != '0') {
    //   query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.mainItem_model['asset_acct_no'] + "'";
    //   obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();

    //       if (data.data['list'].length > 0) {
    //         // (document.getElementById("search_value_2") as HTMLInputElement).value
    //         this.data_model['asset_acct_name'] = data.data['list'][0]['acct_number'] +
    //           "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
    //       }
    //       else {
    //         query = "SELECT * FROM `customer` WHERE `customer_no` = '" + this.mainItem_model['asset_acct_no'] + "'";
    //         obj = { cmd: 'getList', query: query };

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();

    //             if (data.data['list'].length > 0) {
    //               (document.getElementById("search_value_2") as HTMLInputElement).value = data.data['list'][0]['customer_no'] +
    //                 "-" + data.data['list'][0]['customer_name'] + "-" + data.data['list'][0]['customer_name_en'];
    //             }
    //             else {
    //               query = "SELECT * FROM `bank_account` WHERE `acct_number` = '" + this.mainItem_model['asset_acct_no'] + "'";
    //               obj = { cmd: 'getList', query: query };

    //               this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                 .subscribe(data => {
    //                   this.applicationConstants.appComp.hideBusyCursor();

    //                   if (data.data['list'].length > 0) {
    //                     (document.getElementById("search_value_2") as HTMLInputElement).value = data.data['list'][0]['acct_number'] +
    //                       "-" + data.data['list'][0]['bank_acct_number'] + "-" + data.data['list'][0]['account_name'] + "-" +
    //                       data.data['list'][0]['account_name_en'];
    //                   }
    //                   else {
    //                     query = "SELECT * FROM `fixed_asset` WHERE `acct_number` = '" + this.mainItem_model['asset_acct_no'] + "'";
    //                     obj = { cmd: 'getList', query: query };

    //                     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                       .subscribe(data => {
    //                         this.applicationConstants.appComp.hideBusyCursor();

    //                         if (data.data['list'].length > 0) {
    //                           // (document.getElementById("search_value_2") as HTMLInputElement).value
    //                           this.data_model['asset_acct_name'] = data.data['list'][0]['acct_number'] +
    //                             "-" + data.data['list'][0]['asset_number'] + "-" + data.data['list'][0]['asset_name'] + "-" +
    //                             data.data['list'][0]['asset_name_en'];
    //                         }
    //                       });
    //                   }
    //                 });
    //             }
    //           });
    //       }
    //     });
    // }
    // else
    //   // (document.getElementById("search_value_2") as HTMLInputElement).value
    //   this.data_model['asset_acct_name'] = '';

    // if (this.mainItem_model['liability_acct_no'] != '0') {
    //   query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.mainItem_model['liability_acct_no'] + "'";
    //   obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();

    //       if (data.data['list'].length > 0) {
    //         // (document.getElementById("search_value_3") as HTMLInputElement).value
    //         this.data_model['liability_acct_name'] = data.data['list'][0]['acct_number'] +
    //           "-" + data.data['list'][0]['sub_acct_name'] + "-" + data.data['list'][0]['sub_acct_name_en'];
    //       }
    //       else {
    //         query = "SELECT * FROM `supplier` WHERE `supplier_no` = '" + this.mainItem_model['liability_acct_no'] + "'";
    //         obj = { cmd: 'getList', query: query };

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();

    //             if (data.data['list'].length > 0) {
    //               (document.getElementById("search_value_3") as HTMLInputElement).value = data.data['list'][0]['supplier_no'] +
    //                 "-" + data.data['list'][0]['supplier_name'] + "-" + data.data['list'][0]['supplier_name_en'];
    //             }
    //             else {
    //               query = "SELECT * FROM `tax` WHERE `acct_number` = '" + this.mainItem_model['liability_acct_no'] + "'";
    //               obj = { cmd: 'getList', query: query };

    //               this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                 .subscribe(data => {
    //                   this.applicationConstants.appComp.hideBusyCursor();

    //                   if (data.data['list'].length > 0) {
    //                     // (document.getElementById("search_value_3") as HTMLInputElement).value
    //                     this.data_model['liability_acct_name'] = data.data['list'][0]['acct_number'] +
    //                       "-" + data.data['list'][0]['tax_name_ar'] + "-" + data.data['list'][0]['tax_name_en'];
    //                   }
    //                 });
    //             }
    //           });
    //       }
    //     });
    // }
    // else
    //   // (document.getElementById("search_value_3") as HTMLInputElement).value
    //   this.data_model['liability_acct_name'] = '';
  }

  changeItemSubcat() {
    if (this.mainItem_model['item_subcat_id'] != '0') {
      let query = "SELECT * FROM `item_subcat` WHERE `item_subcat_id` = '" + this.mainItem_model['item_subcat_id'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          let item_subcat_obj = data.data['list'][0];
          this.mainItem_model['def_tax_acct'] = item_subcat_obj['def_tax_acct'];
          this.mainItem_model['revenue_acct_no'] = item_subcat_obj['revenue_acct_no'];
          this.mainItem_model['expense_acct_no'] = item_subcat_obj['expense_acct_no'];
          this.mainItem_model['sale_ret_acct_no'] = item_subcat_obj['sale_ret_acct_no'];
          this.mainItem_model['purch_ret_acct_no'] = item_subcat_obj['purch_ret_acct_no'];
          this.fillAcctField();

          if (item_subcat_obj['revenue_acct_no'] == '0') {
            this.mainItem_model['revenue_acct_no'] = this.revenueList[0]['acct_number'];
            this.mainItem_model['sale_ret_acct_no'] = this.saleRetList[0]['acct_number'];
            this.data_model['revenue_acct_name'] = this.revenueList[0]['value'];
            this.data_model['sale_ret_acct_name'] = this.saleRetList[0]['value'];
            this.revenueDetail = this.revenueList[0]['value'];
            this.saleRetDetail = this.saleRetList[0]['value'];
          }

          if (item_subcat_obj['expense_acct_no'] == '0') {
            this.mainItem_model['expense_acct_no'] = data.data['list'][0]['acct_number'];
            this.mainItem_model['purch_ret_acct_no'] = data.data['list'][0]['acct_number'];
            this.data_model['expense_acct_name'] = this.expenseList[0]['value'];
            this.data_model['purch_ret_acct_name'] = this.purchRetList[0]['value'];
            this.expenseDetail = this.expenseList[0]['value'];
            this.purchRetDetail = this.purchRetList[0]['value'];
          }

        });
    }
  }

  onChangeRevenue = function (search_result: object) {
    this.mainItem_model['revenue_acct_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeExpense = function (search_result: object) {
    this.mainItem_model['expense_acct_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeSaleRet = function (search_result: object) {
    this.mainItem_model['sale_ret_acct_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangePruchRet = function (search_result: object) {
    this.mainItem_model['purch_ret_acct_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  // onChangeRevenue = function (acct_number: string) {
  //   console.log(acct_number);
  //   this.mainItem_model['revenue_acct_no'] = acct_number;
  // }

  // onChangeExpense = function (acct_number: string) {
  //   this.mainItem_model['expense_acct_no'] = acct_number;
  // }

  // onChangeSaleRet = function (acct_number: string) {
  //   this.mainItem_model['sale_ret_acct_no'] = acct_number;
  // }

  // onChangePruchRet = function (acct_number: string) {
  //   this.mainItem_model['purch_ret_acct_no'] = acct_number;
  // }

  // onChangeAsset = function (search_result: object) {
  //   this.mainItem_model['asset_acct_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  // }

  // onChangeLiability = function (search_result: object) {
  //   this.mainItem_model['liability_acct_no'] = (search_result['no'] != '' ? search_result['no'] : '0');
  // }

  // searchAcct(caller) {
  //   this.acctDialogRef = this.dialog.open(SearchAcctsComponent, {
  //     hasBackdrop: false,
  //     height: '500px',
  //     data: this.search_dialog_data
  //   });
  //   this.acctDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       if(result != '') {
  //         if(caller == 'acct_income')
  //           this.acct_income = result;
  //         else if(caller == 'acct_expens')
  //           this.acct_expens = result;
  //         else if(caller == 'acct_asset')
  //           this.acct_asset = result;
  //         else if(caller == 'acct_liab')
  //           this.acct_liab = result;
  //       }
  //         //console.log(this.acct_income);
  //     });
  // }

  changeNoBarcode() {
    if (this.subItem_model['no_barcode'] == 1)
      this.subItem_model['sub_item_no'] = '';
  }

  getUnit(event) {
    this.old_unit_id = event.srcElement.value;
  }

  selectUnit() {
    if (this.mainItem_model['main_item_type'] == "industrial" && this.subItemList != undefined) {
      if (this.subItemList.length > 0 && this.subItemContList.length == 0) {
        let index = this.subItemList.length - 1;
        this.subItemList[index]['sub_item_cont'].forEach(element => {
          this.subItemContList.push(Object.assign({}, element));
          this.subItemContList[this.subItemContList.length - 1]['unit_qty'] = this.subItemContList[this.subItemContList.length - 1]['quantity'];
          // if (this.cont_model['quantity'] != 0) {
          //   this.subItemContList[this.subItemContList.length - 1]['quantity'] = (Number(this.subItemContList[this.subItemContList.length - 1]['quantity']) * Number(this.cont_model['quantity']));
          // this.subItemContList[this.subItemContList.length - 1]['total_cost'] = (Number(this.subItemContList[this.subItemContList.length - 1]['quantity']) * Number(this.subItemContList[this.subItemContList.length - 1]['cost']));
          //   this.subItemContList[this.subItemContList.length - 1]['total_price'] = (Number(this.subItemContList[this.subItemContList.length - 1]['quantity']) * Number(this.subItemContList[this.subItemContList.length - 1]['price']));
          // }

          if (this.subItemContList[this.subItemContList.length - 1]['flag'] == 'update') {
            this.subItemContList[this.subItemContList.length - 1]['flag'] = 'new';
            this.subItemContList[this.subItemContList.length - 1]['sub_item_content_id'] = '0';
          }

        });
        //this.subItemContList = this.subItemList[index]['sub_item_cont'];
        this.contDataSource = new MatTableDataSource(this.subItemContList);
        this.contDataSource.sort = this.sort;
        this.subItem_model['sub_item_cont'] = this.subItemContList;
        // console.log(this.subItem_model['sub_item_cont']);

        this.subItem_model['cost'] = 0;
        this.subItem_model['total_cost'] = 0;
        this.subItem_model['price'] = 0;
        this.subItem_model['total_price'] = 0;

        this.subItemContList.forEach(element => {
          this.subItem_model['cost'] += Number(element.total_cost);
          this.subItem_model['total_cost'] += Number(element.total_cost);
          this.subItem_model['price'] += Number(element.total_price);
          this.subItem_model['total_price'] += Number(element.total_price);
        });

        this.subItem_model['cost'] = Number(this.subItem_model['cost'].toFixed(2));
        this.subItem_model['total_cost'] = Number(this.subItem_model['total_cost'].toFixed(2));
        this.subItem_model['price'] = Number(this.subItem_model['price'].toFixed(2));
        this.subItem_model['total_price'] = Number(this.subItem_model['total_price'].toFixed(2));
        this.subItem_model['min_price'] = this.subItem_model['total_price'];
      }
      // let from_unit = this.subItem_model['from_unit'];
      // console.log(from_unit);
      // this.units.forEach(element => {
      //   if (element.unit_id == this.subItem_model['unit_id']) {
      //     from_unit = element.from_unit;
      //   }
      // });

      // if (from_unit != '0') {
      //   this.subItemList.forEach(element => {
      //     if (element.unit_id == from_unit && element.sub_item_cont.length > 0) {
      //       element.sub_item_cont.forEach(element1 => {
      //         this.subItemContList.push(Object.assign({}, element1));
      //       });
      //       console.log(this.subItemContList);
      //       this.dataSource = new MatTableDataSource(this.subItemContList);
      //       this.dataSource.sort = this.sort;
      //       this.subItem_model['sub_item_cont'] = this.subItemContList;
      //     }
      //   });
      // } 

      if (this.subItem_model['sub_item_cont'].length > 0) {
        this.subItem_model['cost'] = 0;
        this.subItem_model['total_cost'] = 0;
        this.subItem_model['price'] = 0;
        this.subItem_model['total_price'] = 0;

        this.subItemContList.forEach(element => {
          this.subItem_model['cost'] += Number(element.total_cost);
          this.subItem_model['total_cost'] += Number(element.total_cost);
          this.subItem_model['price'] += Number(element.total_price);
          this.subItem_model['total_price'] += Number(element.total_price);
        });

        this.subItem_model['cost'] = Number(this.subItem_model['cost'].toFixed(2));
        this.subItem_model['total_cost'] = Number(this.subItem_model['total_cost'].toFixed(2));
        this.subItem_model['price'] = Number(this.subItem_model['price'].toFixed(2));
        this.subItem_model['total_price'] = Number(this.subItem_model['total_price'].toFixed(2));
        this.subItem_model['min_price'] = this.subItem_model['total_price'];
      }
    }

    if (this.mainItem_model['main_item_id'] != '0') {
      // let old_unit;
      // for (let index = 0; index < this.oldUnit.length; index++) {
      //   let element = this.oldUnit[index];
      //   if (element.sub_item_id == this.subItem_model['sub_item_id']) {
      //     old_unit = element.unit_id;
      //     break;
      //   }
      // }

      this.subItemList.forEach(element => {
        if (element.from_unit == this.old_unit_id)
          element.from_unit = this.subItem_model['unit_id'];
      });
      // console.log(this.subItemList);
    }
  }

  changeUnitQuantity() {
    // this.subItem_model['sub_item_cont'] = this.subItemContList;
    // console.log(this.subItem_model['sub_item_cont']);

    // if (this.subItem_model['sub_item_id'] == '0') {}
    this.subItem_model['cost'] = 0;
    this.subItem_model['total_cost'] = 0;
    this.subItem_model['price'] = 0;
    this.subItem_model['total_price'] = 0;

    // change sub item content quantity, total cost and total price
    this.subItemContList.forEach(element => {
      element.quantity = Number(element.unit_qty) * Number(this.subItem_model['unit_quantity']);
      element.total_cost = (Number(element.quantity) * Number(element.cost)).toFixed(2);
      element.total_price = (Number(element.quantity) * Number(element.price)).toFixed(2);

      this.subItem_model['cost'] += Number(element.total_cost);
      this.subItem_model['total_cost'] += Number(element.total_cost);
      this.subItem_model['price'] += Number(element.total_price);
      this.subItem_model['total_price'] += Number(element.total_price);
      // this.contDataSource = new MatTableDataSource(this.subItemContList);
      // this.contDataSource.sort = this.sort;
    });
    this.subItem_model['cost'] = Number(this.subItem_model['cost'].toFixed(2));
    this.subItem_model['total_cost'] = Number(this.subItem_model['total_cost'].toFixed(2));
    this.subItem_model['price'] = Number(this.subItem_model['price'].toFixed(2));
    this.subItem_model['total_price'] = Number(this.subItem_model['total_price'].toFixed(2));
    this.subItem_model['min_price'] = this.subItem_model['total_price'];
  }

  onChangeSearch = function (search_result: object) {
    if (search_result['no'] != '') {
      this.cont_model['sub_item_no'] = search_result['no']

      let query = "SELECT `main_item`.`main_item_name`, `sub_item`.`sub_item_id`, `sub_item`.`sub_item_number`, " +
        "`sub_item`.`cost`, `sub_item`.`price`, `sub_item`.`price_flex`, `sub_item`.`unit_id`, `unit`.`unit_name` " +
        "FROM `main_item`, `sub_item`, `unit` WHERE `sub_item`.`status` = '1' AND `sub_item`.`sub_item_no` = '" +
        this.cont_model['sub_item_no'] + "' AND `sub_item`.`main_item_id` = `main_item`.`main_item_id` AND " +
        "`sub_item`.`unit_id` = `unit`.`unit_id`";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.data['list'].length > 0) {
            let sub_iem = data.data['list'][0];
            this.cont_model['content_number'] = sub_iem.sub_item_number;
            this.cont_model['unit_id'] = sub_iem.unit_id;
            this.cont_model['unit_name'] = sub_iem.unit_name;
            this.cont_model['main_item_name'] = sub_iem.main_item_name;
            this.cont_model['quantity'] = 0;
            this.cont_model['cost'] = sub_iem.cost;
            this.cont_model['total_cost'] = 0;
            this.cont_model['price'] = sub_iem.price;
            this.cont_model['total_price'] = 0;
            this.cont_model['price_flex'] = sub_iem.price_flex;
          }
          // else  
          //   alert (" الرجاء التأكد من رقم الصنف ");
        });
    }
    // else if (this.cont_model['sub_item_no'] == '')
    //   alert (" الرجاء التأكد من الصنف ");
  }

  calculate() {
    if (this.cont_model['quantity'] != 0) {
      this.cont_model['total_cost'] = 0;
      if (this.cont_model['cost'] != 0)
        this.cont_model['total_cost'] = Number((this.cont_model['quantity'] * this.cont_model['cost']).toFixed(2));
      this.cont_model['total_price'] = 0;
      if (this.cont_model['price'] != 0)
        this.cont_model['total_price'] = Number((this.cont_model['quantity'] * this.cont_model['price']).toFixed(2));

      // this.subItemContList[this.subItemContList.length - 1]['quantity'] = (Number(this.subItemContList[this.subItemContList.length - 1]['quantity']) * Number(this.cont_model['quantity']));
      // this.subItemContList[this.subItemContList.length - 1]['total_cost'] = (Number(this.subItemContList[this.subItemContList.length - 1]['quantity']) * Number(this.subItemContList[this.subItemContList.length - 1]['cost']));
      // this.subItemContList[this.subItemContList.length - 1]['total_price'] = (Number(this.subItemContList[this.subItemContList.length - 1]['quantity']) * Number(this.subItemContList[this.subItemContList.length - 1]['price']));

    }
    //else if (this.cont_model['quantity'] == 0)
    //alert (" الرجاء إدخال الكمية ");
  }

  calcTotalPrice() {
    this.cont_model['total_price'] = 0;
    if (this.cont_model['price'] != 0) {
      if (this.cont_model['quantity'] != 0)
        this.cont_model['total_price'] = Number((this.cont_model['quantity'] * this.cont_model['price']).toFixed(2));
      //else if (this.cont_model['quantity'] == 0)
      //alert (" الرجاء إدخال الكمية ");
    }
    //else if (this.cont_model['price'] == 0)
    //alert (" الرجاء إدخال سعر الوحدة ");
  }

  addContent() {
    if (this.cont_model['sub_item_no'] == '') {
      alert(this.Sub_Item_No_Msg);
      return;
    }
    if (this.cont_model['quantity'] == 0) {
      alert(this.Qty_Msg);
      (document.getElementById("quantity") as HTMLInputElement).focus();
      return;
    }
    if (this.cont_model['sub_item_content_id'] == '0') {
      let cont_existed = false;
      this.subItemContList.forEach(element => {
        if (element.content_number == this.cont_model['content_number']) {
          element = this.cont_model;
          cont_existed = true;
        }
      });

      if (!cont_existed) {
        this.cont_model['index'] = this.subItemContList.length;
        this.subItemContList.push(this.cont_model);
      }
    }
    else {
      this.subItemContList.forEach(element => {
        if (element.sub_item_content_id == this.cont_model['sub_item_content_id']) {
          element = this.cont_model;
        }
      });
    }
    this.contDataSource = new MatTableDataSource(this.subItemContList);
    this.contDataSource.sort = this.sort;

    this.subItem_model['cost'] = 0;
    this.subItem_model['total_cost'] = 0;
    this.subItem_model['price'] = 0;
    this.subItem_model['total_price'] = 0;

    this.subItemContList.forEach(element => {
      this.subItem_model['cost'] += Number(element.total_cost.toFixed(2));
      this.subItem_model['total_cost'] += Number(element.total_cost.toFixed(2));
      this.subItem_model['price'] += Number(element.total_price.toFixed(2));
      this.subItem_model['total_price'] += Number(element.total_price.toFixed(2));
    });
    this.subItem_model['sub_item_cont'] = this.subItemContList;
    this.subItem_model['cost'] = Number(this.subItem_model['cost'].toFixed(2));
    this.subItem_model['total_cost'] = Number(this.subItem_model['total_cost'].toFixed(2));
    this.subItem_model['price'] = Number(this.subItem_model['price'].toFixed(2));
    this.subItem_model['total_price'] = Number(this.subItem_model['total_price'].toFixed(2));

    (document.getElementById('search_value_4') as HTMLInputElement).value = '';
    this.cont_model = {
      'table_name': 'sub_item_content', 'sub_item_content_id': '0', 'sub_item_number': '', 'content_number': '',
      'sub_item_no': '', 'flag': 'new', 'key': 'sub_item_content_id', 'unit_id': '', 'unit_name': '',
      'main_item_name': '', 'quantity': 0, 'cost': 0, 'total_cost': 0, 'price': 0, 'total_price': 0, 'price_flex': 0
    };
  }

  editContent(row) {
    this.cont_model = row;
    (document.getElementById('search_value_4') as HTMLInputElement).value = this.cont_model['main_item_name'] + '-' +
      this.cont_model['sub_item_no'];
  }

  deleteContent(row) {
    if (confirm(this.Del_Content_Msg)) {
      if (row.sub_item_content_id == '0') {
        this.subItemContList.splice(row.index, 1);
        this.contDataSource = new MatTableDataSource(this.subItemContList);
        this.contDataSource.sort = this.sort;

        let index = 0;
        this.subItem_model['cost'] = 0;
        this.subItem_model['total_cost'] = 0;
        this.subItem_model['price'] = 0;
        this.subItem_model['total_price'] = 0;

        this.subItemContList.forEach(element => {
          element.index = index;
          this.subItem_model['cost'] += Number(element.total_cost.toFixed(2));
          this.subItem_model['total_cost'] += Number(element.total_cost.toFixed(2));
          this.subItem_model['price'] += Number(element.total_price.toFixed(2));
          this.subItem_model['total_price'] += Number(element.total_price.toFixed(2));
          index++;
        });
        this.subItem_model['sub_item_cont'] = this.subItemContList;
      }
      else if (row.sub_item_content_id != '0') {
        let values = [{ 'table_name': row.table_name, 'sub_item_content_id': row.sub_item_content_id }];
        let obj = { cmd: 'deleteRec', values: values };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.status['type'] == 'success') {
              alert(this.Success_Msg);
              this.subItemContList.splice(row.index, 1);
              this.contDataSource = new MatTableDataSource(this.subItemContList);
              this.contDataSource.sort = this.sort;

              let index = 0;
              this.subItem_model['cost'] = 0;
              this.subItem_model['total_cost'] = 0;
              this.subItem_model['price'] = 0;
              this.subItem_model['total_price'] = 0;

              this.subItemContList.forEach(element => {
                element.index = index;
                this.subItem_model['cost'] += Number(element.total_cost.toFixed(2));
                this.subItem_model['total_cost'] += Number(element.total_cost.toFixed(2));
                this.subItem_model['price'] += Number(element.total_price.toFixed(2));
                this.subItem_model['total_price'] += Number(element.total_price.toFixed(2));
                index++;
              });
              this.subItem_model['sub_item_cont'] = this.subItemContList;
            }
            else {
              alert(this.Error_Msg);
            }
          });
      }
    }
  }

  changePrice(event) {
    let tax_price = Number(event.srcElement.value);
    let element;
    if (this.mainItem_model['def_tax_acct'] != '0') {
      for (let index = 0; index < this.taxes.length; index++) {
        element = this.taxes[index];
        if (element.acct_number == this.mainItem_model['def_tax_acct']) {
          if (Number(element.tax_perc) != 0)
            this.subItem_model['price'] = Number((tax_price / (1 + Number(element.tax_perc) / 100)).toFixed(2));
          else if (Number(element.tax_amount) != 0)
            this.subItem_model['price'] = Number((tax_price - Number(element.tax_amount)).toFixed(2));
          break;
        }

      }
    }
    // let tax_id = 
  }

  addSubItemCat() {
    if (this.subItem_model['no_barcode'] == 0 && this.subItem_model['sub_item_no'] == '') {
      alert(this.Sub_Item_No_Msg);
      (document.getElementById("sub_item_no") as HTMLInputElement).focus();
      return;
    }
    if (this.subItem_model['unit_id'] == '0') {
      alert(this.Unit_Msg);
      (document.getElementById("unit_id") as HTMLInputElement).focus();
      return;
    }

    this.units.forEach(element => {
      if (element.unit_id == this.subItem_model['unit_id'])
        this.subItem_model['unit_name'] = element.unit_name;
    });

    if (this.subItem_model['sub_item_id'] == '0') {
      let item_existed = false;
      this.subItemList.forEach(element => {
        if (element.unit_id == this.subItem_model['unit_id'] && element.from_unit == this.subItem_model['from_unit']) {
          element = this.subItem_model;
          item_existed = true;
        }
      });

      if (!item_existed) {
        this.subItem_model['index'] = this.subItemList.length;
        this.subItemList.push(this.subItem_model);
      }
    }
    else {
      this.subItemList.forEach(element => {
        if (element.sub_item_id == this.subItem_model['sub_item_id']) {
          element = this.subItem_model;
        }
      });
    }
    this.dataSource = new MatTableDataSource(this.subItemList);
    this.dataSource.sort = this.sort;

    this.subItem_model = {
      'table_name': 'sub_item', 'sub_item_id': '0', 'sub_item_number': '0', 'main_item_id': '', 'unit_id': '0',
      'unit_name': '', 'from_unit': '0', 'unit_quantity': 0, 'no_barcode': 1, 'sub_item_no': '', 'flag': 'new',
      'key': 'sub_item_id', 'price': 0, 'total_price': 0, 'cost': 0, 'total_cost': 0, 'min_qty': 0,
      'min_sale_qty': 1, 'price_flex': 0, 'min_price': 0, 'is_sale': 0, 'is_purch': 0, 'sub_item_cont': [],
      'warranty_day': '', 'warranty_kilometer': ''
    };

    if (this.mainItem_model['main_item_type'] == 'industrial') {
      (document.getElementById('search_value_4') as HTMLInputElement).value = '';
      this.cont_model = {
        'table_name': 'sub_item_content', 'sub_item_content_id': '0', 'sub_item_number': '', 'content_number': '',
        'sub_item_no': '', 'flag': 'new', 'key': 'sub_item_content_id', 'unit_id': '', 'unit_name': '',
        'main_item_name': '', 'quantity': 0, 'cost': 0, 'total_cost': 0, 'price': 0, 'total_price': 0,
        'price_flex': 0
      };

      this.subItemContList = [];
      this.contDataSource = new MatTableDataSource(this.subItemContList);
      this.contDataSource.sort = this.sort;
    }
    this.show_primary_unit = false;
  }

  // addSubItem() {
  //   this.sub_dialog_data = {'main_item_type': this.mainItem_model['main_item_type'], 
  //     'all_sub_item': this.subItemList};

  //   this.subItemCatDialogRef = this.dialog.open(SubItemCatComponent, {
  //     hasBackdrop: false,
  //     data: this.sub_dialog_data
  //   });
  //   this.subItemCatDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       if(result != undefined) {
  //         result.index = this.dp.length;
  //         this.dp.push(result);
  //         this.dataSource = new MatTableDataSource(this.dp);
  //         this.dataSource.sort = this.sort;
  //         this.subItemList = this.dp;
  //       }
  //     });
  // }

  editSubItem(row) {
    this.subItem_model = row;
    this.show_primary_unit = (row.from_unit == '0');

    if (this.mainItem_model['main_item_type'] == 'industrial') {
      this.subItemContList = row.sub_item_cont;
      this.contDataSource = new MatTableDataSource(this.subItemContList);
      this.contDataSource.sort = this.sort;

      console.log('from_unit: ' + row.from_unit + ', unit_qty:' + this.subItemContList[0]['unit_qty']);
      if (row.from_unit != '0' && this.subItemContList[0]['unit_qty'] == undefined) {
        let previousItem = this.subItemList[0]['sub_item_cont'];
        console.log(previousItem);
        for (let index = 1; index < this.subItemList.length; index++) {
          if (this.subItemList[index]['unit_id'] == row.unit_id && this.subItemList[index]['from_unit'] == row.from_unit) {

            previousItem = this.subItemList[index - 1]['sub_item_cont'];
            console.log(previousItem);
            // let sub_item_cont = this.subItemList[index]['sub_item_cont'];
            for (let indx = 0; indx < this.subItemContList.length; indx++) {
              if (previousItem[indx] != undefined)
                this.subItemContList[indx]['unit_qty'] = previousItem[indx]['quantity'];

            }
            return false;
          }
        }
      }

      (document.getElementById('search_value_4') as HTMLInputElement).value = '';
      this.cont_model = {
        'table_name': 'sub_item_content', 'sub_item_content_id': '0', 'sub_item_number': '', 'content_number': '',
        'sub_item_no': '', 'flag': 'new', 'key': 'sub_item_content_id', 'unit_id': '', 'unit_name': '', 'main_item_name': '', 'quantity': 0, 'cost': 0,
        'total_cost': 0, 'price': 0, 'total_price': 0, 'price_flex': 0
      };
    }

    // this.sub_dialog_data = {'main_item_type': this.mainItem_model['main_item_type'], 'sub_item': row};
    // this.subItemCatDialogRef = this.dialog.open(SubItemCatComponent, {
    //   hasBackdrop: false,
    //   data: this.sub_dialog_data
    // });
    // this.subItemCatDialogRef
    //   .afterClosed()
    //   .subscribe(result => {
    //     if(result != undefined) {
    //       this.dp.forEach(element => {
    //         if(element.index == result.index) {
    //           element = result;
    //         }
    //       });
    //       this.dataSource = new MatTableDataSource(this.dp);
    //       this.dataSource.sort = this.sort;
    //       this.subItemList = this.dp;
    //     }
    //   });
  }

  deleteSubItem(row) {
    if (confirm(this.Del_Sub_Item)) {
      if (row.sub_item_id == '0') {
        this.subItemList.splice(row.index, 1);
        this.dataSource = new MatTableDataSource(this.subItemList);
        this.dataSource.sort = this.sort;

        let index = 0;
        this.subItemList.forEach(element => {
          element.index = index;
          index++;
        });
        // this.subItemList = this.dp;
      }
      else if (row.sub_item_id != '0') {
        let values = [];
        values.push({ 'table_name': row.table_name, 'sub_item_id': row.sub_item_id });
        if (row.sub_item_cont.length > 0) {
          row.sub_item_cont.forEach(element => {
            if (element.sub_item_content_id != '0')
              values.push({ 'table_name': element.table_name, 'sub_item_content_id': element.sub_item_content_id });
          });
        }
        let obj = { cmd: 'deleteRec', values: values };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.status['type'] == 'success') {
              alert(this.Success_Msg);
              this.subItemList.splice(row.index, 1);
              this.dataSource = new MatTableDataSource(this.subItemList);
              this.dataSource.sort = this.sort;

              let index = 0;
              this.subItemList.forEach(element => {
                element.index = index;
                index++;
              });
              // this.subItemList = this.dp;
            }
            else {
              alert(this.Error_Msg);
            }
          });
      }
    }
  }

  add() {
    if (this.data_model['item_cat_id'] == '0') {
      alert(this.Main_Cat_Msg);
      if (this.tabGroup.selectedIndex != 0) {
        this.tabGroup.selectedIndex = 0;
        this.heightField = 'item_cat_id';
      }
      else
        (document.getElementById("item_cat_id") as HTMLInputElement).focus();
      return;
    }

    if (this.mainItem_model['item_subcat_id'] == '0') {
      alert(this.Sub_Cat_Msg);
      if (this.tabGroup.selectedIndex != 0) {
        this.tabGroup.selectedIndex = 0;
        this.heightField = 'item_subcat_id';
      }
      else
        (document.getElementById("item_subcat_id") as HTMLInputElement).focus();
      return;
    }

    if (this.mainItem_model['main_item_name'] == '') {
      alert(this.Sub_Item_Name_Msg);
      if (this.tabGroup.selectedIndex != 0) {
        this.tabGroup.selectedIndex = 0;
        this.heightField = 'main_item_name';
      }
      else
        (document.getElementById("main_item_name") as HTMLInputElement).focus();
      return;
    }

    if (this.subItemList.length == 0) {
      alert(this.Cat_Msg);
      return;
    }

    if (this.mainItem_model['revenue_acct_no'] == '0') {
      alert(this.Revenue_Acct_Msg);
      return;
    }
    if (this.mainItem_model['expense_acct_no'] == '0') {
      alert(this.Expense_Acct_Msg);
      return;
    }

    let primary = false;
    this.subItemList.forEach(element => {
      if (!primary && element.from_unit == '0') {
        primary = true;
      }
      // this.units.forEach(element2 => {
      //   if (element.unit_id == element2.unit_id && element2.unit_type == 'primary') {
      //     primary = true;
      //   }
      // });
    });

    if (!primary) {
      alert(this.Cat_Unit_Msg);
      return;
    }

    let values = [];
    // let where = [];
    // let where1 = [];
    // let update_values = [];
    // let update_values1 = [];
    let obj;

    let sub_item_id;
    let sub_item_no;
    let sub_item_number;
    let sub_itme_cont;

    this.mainItem_model['stock_link'] = (this.mainItem_model['stock_link'] ? 1 : 0);
    this.mainItem_model['is_expire'] = (this.mainItem_model['is_expire'] ? 1 : 0);

    if (this.mainItem_model['main_item_id'] == '0') {
      values.push(this.mainItem_model);
      this.subItemContList = [];

      this.subItemList.forEach(element => {
        element.is_sale = (element.is_sale ? 1 : 0);
        element.is_purch = (element.is_purch ? 1 : 0);
        element.price_flex = (element.price_flex ? 1 : 0);

        delete element.index;
        delete element.unit_name;
        delete element.no_barcode;
        delete element.total_cost;
        delete element.total_price;
        if (element.sub_item_cont != undefined) {
          if (element.sub_item_cont.length > 0)
            this.subItemContList.push(Object.assign({}, element));
          delete element.sub_item_cont;
        }

        values.push(element);
      });

      obj = {
        cmd: 'add', values: values, pk: 'main_item_no', id: 'main_item_id', main_table: 'main_item',
        prefix: ''
      };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] != 'success')
            alert(this.Cat_Error_Msg);

          else if (data.status['type'] == 'success') {
            let sub_item_list = data.status['msg'];
            values = [];

            sub_item_list.forEach(element => {
              if (element.table_name == 'sub_item') {
                sub_item_id = element.id;
                sub_item_no = this.utils.returnZeros(sub_item_id);
                sub_item_number = this.applicationConstants.company_id;

                if (Number(this.applicationConstants.branch_id) < 10)
                  sub_item_number += '0' + this.applicationConstants.branch_id;
                else
                  sub_item_number += this.applicationConstants.branch_id;
                sub_item_number += sub_item_no;

                values.push({
                  'table_name': 'sub_item', 'sub_item_id': sub_item_id, 'flag': 'update',
                  'key': 'sub_item_id', 'sub_item_number': sub_item_number
                });

                if (element.sub_item_no == '')
                  values[values.length - 1]['sub_item_no'] = sub_item_no;

                // where.push({ 'sub_item_id': sub_item_id });
                // update_values.push({
                //   'table_name': 'sub_item', 'sub_item_no': sub_item_no, 'sub_item_number': sub_item_number
                // });

                // else {
                //   where.push({ 'sub_item_id': sub_item_id });
                //   update_values.push({ 'table_name': 'sub_item', 'sub_item_number': sub_item_number });
                // }

                if (this.mainItem_model['main_item_type'] == 'industrial' && this.subItemContList.length > 0) {
                  this.subItemContList.forEach(element1 => {
                    if (element1.unit_id == element.unit_id && element1.from_unit == element.from_unit) {
                      sub_itme_cont = element1.sub_item_cont;
                      sub_itme_cont.forEach(element2 => {
                        delete element2.index;
                        delete element2.sub_item_no;
                        delete element2.main_item_name;
                        delete element2.total_cost;
                        delete element2.total_price;
                        delete element2.price_flex;
                        delete element2.unit_id;
                        delete element2.unit_name;
                        if (element2.unit_qty != undefined)
                          delete element2.unit_qty;
                        element2.sub_item_number = sub_item_number;

                        values.push(element2);
                      });
                    }
                  });
                }
              }
            });

            // obj = { cmd: 'update', values: update_values, where: where };
            console.log(values);
            obj = { cmd: 'updateAdv', values: values };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.router.navigate(['sub_menu/5/sub_item_list']);

                  // if (values.length > 0) {
                  //   obj = { cmd: 'add', values: values };
                  //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                  //     .subscribe(data => {
                  //       this.applicationConstants.appComp.hideBusyCursor();
                  //       if (data.status['type'] == 'success') {
                  //         alert(" تمت العملية بنجاح ");
                  //         this.router.navigate(['sub_menu/5/sub_item_list']);
                  //       }
                  //       else
                  //         alert(" حدث خطأ في حفظ المكونات، الرجاء المحاولة مرة أخرى ");
                  //     });
                  // }
                  // else {
                  //   alert(" تمت العملية بنجاح ");
                  //   this.router.navigate(['sub_menu/5/sub_item_list']);
                  // }
                }
                else
                  alert(this.Cat_Edit_Err_Msg);
              });
          }
        });
    }
    else {
      let values1 = [];
      this.subItemContList = [];
      let subItemContent = [];

      values.push(this.mainItem_model);
      // update_values.push(this.mainItem_model);
      // where.push({ 'main_item_id': this.mainItem_model['main_item_id'] });

      this.subItemList.forEach(element => {
        element.main_item_id = this.mainItem_model['main_item_id'];
        element.is_sale = (element.is_sale ? 1 : 0);
        element.is_purch = (element.is_purch ? 1 : 0);
        element.price_flex = (element.price_flex ? 1 : 0);

        delete element.index;
        delete element.unit_name;
        delete element.no_barcode;
        delete element.total_cost;
        delete element.total_price;

        if (element.sub_item_id == '0') {
          if (element.sub_item_cont != undefined) {
            if (element.sub_item_cont.length > 0)
              this.subItemContList.push(Object.assign({}, element));
            delete element.sub_item_cont;
          }

          values1.push(element);
        }
        else {
          subItemContent = [];

          element.flag = 'update';
          element.key = 'sub_item_id';

          if (element.sub_item_cont != undefined) {
            if (element.sub_item_cont.length > 0)
              subItemContent.push(Object.assign({}, element));
            delete element.sub_item_cont;
          }
          // element.sub_item_id = String(element.sub_item_id);

          if (element.sub_item_no == '')
            element.sub_item_no = this.utils.returnZeros(element.sub_item_id);

          values.push(element);

          if (this.mainItem_model['main_item_type'] == 'industrial' && subItemContent.length > 0) {
            sub_itme_cont = subItemContent[0].sub_item_cont;
            sub_itme_cont.forEach(element2 => {
              delete element2.index;
              delete element2.sub_item_no;
              delete element2.main_item_name;
              delete element2.total_cost;
              delete element2.total_price;
              delete element2.price_flex;
              delete element2.unit_id;
              delete element2.unit_name;
              if (element2.unit_qty != undefined)
                delete element2.unit_qty;
              element2.sub_item_number = element.sub_item_number;

              values.push(element2);

              // if (element2.sub_item_content_id == '0')
              //   values1.push(element2);
              // else {
              //   where1.push({ 'sub_item_content_id': element2.sub_item_content_id })
              //   update_values1.push(element2);
              // }
            });
          }
          // where.push({ 'sub_item_id': element.sub_item_id });
          // update_values.push(element);
        }
      });

      console.log(values);
      obj = { cmd: 'updateAdv', values: values };
      // obj = { cmd: 'update', values: update_values, where: where };
      // console.log(obj);

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] != 'success')
            alert(this.Cat_Inf_Err_Msg);

          else if (data.status['type'] == 'success') {
            if (values1.length > 0) {
              obj = { cmd: 'add', values: values1 };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.status['type'] == 'success') {
                    let sub_item_list = data.status['msg'];
                    values = [];

                    sub_item_list.forEach(element => {
                      if (element.table_name == 'sub_item') {
                        sub_item_id = element.id;
                        sub_item_no = this.utils.returnZeros(sub_item_id);
                        sub_item_number = this.applicationConstants.company_id;

                        if (Number(this.applicationConstants.branch_id) < 10)
                          sub_item_number += '0' + this.applicationConstants.branch_id;
                        else
                          sub_item_number += this.applicationConstants.branch_id;
                        sub_item_number += sub_item_no;

                        values.push({
                          'table_name': 'sub_item', 'sub_item_id': sub_item_id, 'flag': 'update',
                          'key': 'sub_item_id', 'sub_item_number': sub_item_number
                        });

                        if (element.sub_item_no == '')
                          values[values.length - 1]['sub_item_no'] = sub_item_no;

                        if (this.mainItem_model['main_item_type'] == 'industrial' && this.subItemContList.length > 0) {
                          this.subItemContList.forEach(element1 => {
                            if (element1.unit_id == element.unit_id && element1.from_unit == element.from_unit) {
                              sub_itme_cont = element1.sub_item_cont;
                              sub_itme_cont.forEach(element2 => {
                                delete element2.index;
                                delete element2.sub_item_no;
                                delete element2.main_item_name;
                                delete element2.total_cost;
                                delete element2.total_price;
                                delete element2.price_flex;
                                delete element2.unit_id;
                                delete element2.unit_name;
                                if (element2.unit_qty != undefined)
                                  delete element2.unit_qty;
                                element2.sub_item_number = sub_item_number;

                                values.push(element2);
                              });
                            }
                          });
                        }
                      }
                    });


                    console.log(values);
                    obj = { cmd: 'updateAdv', values: values };
                    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                      .subscribe(data => {
                        this.applicationConstants.appComp.hideBusyCursor();

                        if (data.status['type'] == 'success') {
                          alert(this.Success_Msg);
                          this.router.navigate(['sub_menu/5/sub_item_list']);
                        }
                        else
                          alert(this.Content_Error_Msg);
                      });
                  }
                  else
                    alert(this.New_Cat_Error_Msg);

                });
            }
            else {
              alert(this.Success_Msg);
              this.router.navigate(['sub_menu/5/sub_item_list']);
            }
          }
        });
    }
  }

}
